import styled from 'styled-components';
import { OrderPanelStyledDS } from '../OrderPanelStyled.DS';
import { PriceCss } from '../../OrderPanelStyled';
import { rem } from 'polished';

export const OrderPanelStyledDSGB = styled(OrderPanelStyledDS)`
    .wrapper {
        .section {
            border-color: ${({ theme }) => theme.colors.grey11} !important;
            border-width: 1px !important;

            .order-panel-price-container {
                ${PriceCss}
                .content {
                    .header {
                        font-size: ${rem(14)};
                    }
                    .body {
                        .footer {
                            .promotionalTextWrapper:first-child {
                                display: flex;
                                flex-direction: row;
                            }
                        }
                    }
                }
            }
        }
    }

    .content {
        .body {
            .body-wrapper {
                .price {
                    font-size: ${rem(16)} !important;

                    .priceOtr {
                        font-size: ${rem(16)} !important;
                    }
                }
            }
        }
    }
`;
